<div class="icon-type-item" [ngSwitch]="itemType">
    <ng-template [ngSwitchCase]="helper.isCustomerType">
        <span class="material-icons" title="{{ 'CONSTANTS.CUSTOMER' | translate }}">group_work</span>
    </ng-template>
    <ng-template [ngSwitchCase]="helper.isOrganizationType">
        <span class="material-icons" title="{{ 'CONSTANTS.ORGANIZATION' | translate }}">account_balance</span>
    </ng-template>
</div>